import React, { PropsWithChildren } from "react";
import cx from "classnames";
import { dataTestIds } from "data-testids";

interface Props {
  type?: "error" | "info";
  className?: string;
}

const StatusMessage = ({
  children,
  type = "info",
  className,
}: PropsWithChildren<Props>) => {
  const statusMessageClass = cx(
    "p-2.5 border rounded",
    {
      "border-red-cardinal bg-red-pale": type === "error",
      "bg-orange-pale border-orange-burnt": type === "info",
    },
    className
  );

  return (
    <div
      className={statusMessageClass}
      data-testid={dataTestIds.componentLibrary["Atoms.StatusMessage.Card"]}
    >
      {children}
    </div>
  );
};

export default StatusMessage;
